import xoneIcon from '../assets/xone-icon.svg?raw';
import { BRAND } from '../lib/brand';

/**
 * The brand's mark (lib/brand.ts). Xone: the X (assets/xone-icon.svg) in the current text colour, so
 * it suits the menu rail in every colour scheme and theme. MyBooks: the blue X on white in light mode
 * and the white X on the blue tile in dark mode (public/logo-light.png, logo-dark.png); both are
 * rendered and the stylesheet shows the one for the current theme. Decorative: the link or heading
 * around it carries the name.
 */
export function Logo({ size }: { size?: number }) {
  const style = size ? { width: size, height: size } : undefined;
  if (BRAND.id === 'xone') return <span className="logo logo-mark" style={style} dangerouslySetInnerHTML={{ __html: xoneIcon }} />;
  return (
    <span className="logo" style={style}>
      <img className="logo-light" src="/logo-light.png" alt="" draggable={false} />
      <img className="logo-dark" src="/logo-dark.png" alt="" draggable={false} />
    </span>
  );
}
